import React, { useRef, useState } from "react"
import { StyledSelectButton } from "components/views/atoms/forms/StyledInputs"
import { HR, Spacer } from "components/views/atoms/Atoms"
import { MultiPathSVG } from "components/views/SVG"
import { H3 } from "@carrotfertility/carotene"
import { Body } from "components/views/atoms/Bodies"
import { useOnClickOutside } from "../../../../utils/hooks/useOnClickOutside"
import { Checkbox } from "../Checkbox"

/**
 * A select box that lets you pick multiple options.
 */
const FormMultiSelect = React.forwardRef(({ handleInputChange, choices, name, valid }, ref) => {
  const [state, setState] = useState({
    options: choices,
    value: "",
    showOptions: false
  })

  const optionsRef = useRef()

  const hideOptions = () => {
    setState({ ...state, showOptions: false })
  }

  useOnClickOutside(optionsRef, hideOptions)

  const handleOptionClick = (event) => {
    const selectedValue = event._dispatchInstances.key

    const newOptions = state.options.map((option) => {
      if (option.id === selectedValue) {
        return { ...option, selected: !option.selected }
      } else {
        return { ...option }
      }
    })

    const selectedOptionIds = newOptions.filter((option) => option.selected).map((option) => option.id)

    const selectedOptionIdsString = JSON.stringify(selectedOptionIds)
    setState({
      ...state,
      options: newOptions,
      value: selectedOptionIdsString
    })

    const eventToSend = {
      target: {
        type: "text",
        value: selectedOptionIds,
        name: name
      }
    }

    handleInputChange && handleInputChange(eventToSend)
  }

  const toggleOptions = (event) => {
    event.preventDefault()
    setState({ ...state, showOptions: !state.showOptions })
  }
  return (
    <div ref={optionsRef} className={`tl relative w-100 border-box multiselect-${name}`}>
      <input name={name} ref={ref} type="hidden" value={state.value} />
      <SelectButton name={name} toggleOptions={toggleOptions} options={state.options} valid={valid} />
      <RenderOptions
        name={name}
        showOptions={state.showOptions}
        options={state.options}
        toggleOptions={toggleOptions}
        handleOptionClick={handleOptionClick}
      />
    </div>
  )
})

const SelectButton = ({ toggleOptions, options, valid, name }) => {
  return (
    <StyledSelectButton onClick={toggleOptions} valid={valid} id={`multiselect-${name}-button`}>
      <div className={"tl w-90"}>
        {options.filter((option) => option.selected).length > 0 ? (
          <H3 className="truncate">
            {options
              .filter((option) => option.selected)
              .map((option) => option.label)
              .join(", ")}
          </H3>
        ) : (
          <Body>Select all that apply</Body>
        )}
      </div>
      <div className="pointer h-100 flex flex-row items-center pl1 pr3">
        <MultiPathSVG iconName="disclosure-arrow" />
      </div>
    </StyledSelectButton>
  )
}

const RenderOptions = ({ showOptions, options, toggleOptions, handleOptionClick, name }) => {
  return (
    <>
      {showOptions && (
        <div className={"absolute top-1 left-0 bg-white br3 shadow-modal ba b--black-20 w-100"}>
          <div style={{ paddingLeft: 22, paddingRight: 22 }}>
            <div
              className={"pointer flex justify-between  items-center"}
              onClick={toggleOptions}
              style={{ paddingTop: 16 }}
            >
              <Body>Select all that apply</Body>
              <div className="pointer h-100 flex flex-row">
                <MultiPathSVG iconName="disclosure-arrow" />
              </div>
            </div>
            <Spacer height={0.5} />
            <HR color={"black-10"} />
          </div>
          <div className={"pa1"} />
          {options.map((option) => (
            <div
              id={`multiselect-${name}-${option.id}`}
              className={"hover-bg-very-light-carrot-orange pl3 flex flex-row"}
              style={{ padding: 10, paddingLeft: 22, paddingRight: 22 }}
              key={option.id}
              value={option.id}
              onClick={handleOptionClick}
            >
              <Checkbox checked={option.selected} onChange={() => {}} size={"24px"} />
              <div className={"dib cursor-default truncate"} style={{ paddingLeft: 10 }}>
                {option.selected ? (
                  <H3 className="truncate">{option.label}</H3>
                ) : (
                  <Body additionalClasses={"truncate"}>{option.label}</Body>
                )}
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  )
}

export default FormMultiSelect
